import { createAction, props } from "@ngrx/store";
import { Company } from "../../models/company";
import { User } from "../../models/user";

export const findCompanyAct = createAction('findCompanyEffect', props<{ id: string }>());
export const loadCompanyByIdAct = createAction('loadCompanyByIdEffect', props<{ company: Company }>());

export const findCompanyLogoAct = createAction('findCompanyLogoEffect', props<{ id: string }>());
export const loadCompanyLogoByIdAct = createAction('loadCompanyLogoByIdEffect', props<{ logoUrl: string }>());

export const resetCompanyAct = createAction('resetCompanyEffect');

export const updateCompanyAct = createAction('updateCompanyEffect', props<{ companyUpdated: Company }>());
export const updateSuccessCompanyAct = createAction('updateSuccessCompanyEffect', props<{ companyUpdated: Company }>());

export const updateCompanyLogoAct = createAction('updateCompanyLogoEffect', props<{ id: string, file: File }>());
export const updateSuccessCompanyLogoAct = createAction('updateSuccessCompanyLogoEffect', props<{ companyUpdated: Company }>());

/*export const saveCompanyAct = createAction('saveCompanyEffect', props<{ companyNew: Company }>());
export const saveSuccessCompanyAct = createAction('saveSuccessCompanyEffect', props<{ companyNew: Company }>());*/

export const setViolationsCompanyAct = createAction('setViolationsCompanyEffect', props<{ companyForm: Company, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );

export const findUsersOfCompanyAct = createAction('findUsersOfCompanyEffect', props<{ id: string }>());
export const loadUsersOfCompanyAct = createAction('loadUsersOfCompanyEffect', props<{ usersOfCompany: User[] }>());
